import { Row, Col, Icon, Button } from 'antd';

export default class Pending extends React.Component {
    constructor(props) { super(props); }
    handleSendReactivateAccount = () => {
        const {services,state} = this.props;
        const {registrationForm} = state;
        const {login} = registrationForm;
        const {username} = login;
        services.accountReactivation(username);
    }
    
    render() {
        return (
            <div className='afsp-login-indicator-status-error'>
                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                    <Icon type='exclamation-circle-o' style={{ fontSize: '20px', marginRight: '10px' }} />
                    <span style={{ fontSize: '16px', fontStyle: 'italic' }}>
                        {'Account is disabled.'}
                    </span>
                    <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '16px' }}>
                        <Col span={24}>
                            <div style={{ fontStyle: 'italic', lineHeight: '14px' }}>
                                {'For further assistance, please contact FTSP Help:'}
                                <div style={{ marginTop: '5px' }}>
                                    <span style={{ fontWeight: 'bold' }}>
                                        <a href='mailto:FTSP.Help@tsa.dhs.gov'>
                                            {'FTSP.Help@tsa.dhs.gov'}
                                        </a>
                                    </span>
                                    {'.'}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}